import React, { Suspense } from "react";
import styled, { useTheme } from "styled-components";

import { ReactComponent as GenericAvatar } from "../../Assets/iconsv2/generic/GenericAvatar.svg";
import { ReactComponent as CheckEmpty } from "../../Assets/iconsv2/generic/checkEmpty.svg";
import { ReactComponent as Check } from "../../Assets/iconsv2/generic/check.svg";
import { displayUserAvatar } from "../../Helpers/chatHelper/AvatarHelper";

const OtherParticipant = ({ item, selected, handleSelectContact, noCheck }) => {
  const theme = useTheme();
  const handleClick = (item) => {
    handleSelectContact(item);
  };

  return (
    <Warpper>
      <FoundContact onClick={() => handleClick(item)}>
        <FoundContactAvatar>{displayUserAvatar(item)}</FoundContactAvatar>
        <p>{item}</p>
        {!noCheck && (
          <CheckWrapper>
            {selected ? (
              <CheckedWrapper>
                <Check />
              </CheckedWrapper>
            ) : (
              <CheckEmptyWrapper>
                <CheckEmpty />
              </CheckEmptyWrapper>
            )}
          </CheckWrapper>
        )}
      </FoundContact>
    </Warpper>
  );
};

export default OtherParticipant;
const Warpper = styled.div`
  display: flex;
  align-items: center;
`;

const FoundContact = styled.div`
  display: flex;
  align-items: center;
padding:8px 16px;
  gap: 16px;
  cursor: pointer;
  width: 100%;
  overflow: hidden;
    &:hover {
    background: ${({ theme }) => theme.call.callElementSelectedBackground};
  }
  p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    width: 100%;
  }
`;

const FoundContactAvatar = styled.div`
  display: flex;
  height: 42px;
  width: 42px;
  max-width: 42px;
  min-height: 42px;
  min-width: 42px;
  max-height: 42px;
  border-radius: 100%;
  position: relative;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }

  svg {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

const CheckWrapper = styled.div`
  display: flex;
  margin-left: auto;
  svg {
    fill: transparent;
    color: transparent;
  }
`;
const CheckedWrapper = styled.div`
  display: flex;
  svg {
    color: ${({ theme }) => theme.check.background};
    fill: ${({ theme }) => theme.check.checkSign};
  }
`;
const CheckEmptyWrapper = styled.div`
  display: flex;
  svg {
    color: ${({ theme }) => theme.check.border};
    stroke: ${({ theme }) => theme.check.checkSign};
  }
`;
